export default {
  meals: []
}
